import React from 'react';
import escuelaBiblica1 from './assets/img/escuelaBiblica1.jpg';
import { Typography, Box } from '@mui/material';

const EscuelaBiblica = () => {
  return (
    <section className="page-section">
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '550px',
          overflow: 'hidden',
        }}
      >
        {/* Image filling the section and cropped if needed */}
        <img
          src={escuelaBiblica1}
          alt="Escuela Biblica"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover', // Ensures it fills and crops
            display: 'block',
          }}
        />

        {/* Overlay background */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1,
          }}
        />

        {/* Text content */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            textAlign: 'center',
            zIndex: 2,
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom>
            Escuela Bíblica
          </Typography>

          <div style={{display: 'flex', gap: '1rem', justifyContent: 'center', backgroundColor: 'var(--primary-color)', padding: '1rem', borderRadius: '8px'}}>
          <Typography variant="body2" component="p">
            Domingos 11:00am - 11:30am
          </Typography> 

          </div>
        </Box>
      </div>
    </section>
  );
};

export default EscuelaBiblica;
